// extracted by mini-css-extract-plugin
module.exports = {"globals":"\"../GlobalStyles.css\"","screen-sm":"1024px","screen-lg":"1680px","screen-xl":"1920px","textColor":"#f2e0f7"};